import CommonUtils from '@/resources/utils/common-utils'
import API from '@/config/api'

const refundAPI = {
    state: {},
    mutations: {
      getCanRefundList(state, data) { // 获取可退款列表
        data.url = API.refund.getCanRefundList
        CommonUtils.GetRequest(data)
      },
      getRefundedList(state, data) { // 获取退款记录列表
        data.url = API.refund.getRefundedList
        CommonUtils.GetRequest(data)
      },
      getRefundDetail(state, data) { // 获取可退款详情
        data.url = API.refund.getRefundDetail
        CommonUtils.GetRequest(data)
      },
      fetchSureRefund(state, data) { // 退款发起
        data.url = API.refund.fetchSureRefund
        CommonUtils.PostRequest(data)
      }
    }
}

export default refundAPI;



// WEBPACK FOOTER //
// ./src/store/modules/refund.js